import Logo from '@/components/logo';
import { cn } from '@/components/ui';

interface Props {
  open: boolean;
}

const DrawerHeader = ({ open }: Props) => {
  return (
    <div
      className={cn(
        'flex min-h-header shrink-0 items-center',
        // Open: original compact brand row. Collapsed: logo sits in the mini-rail
        // clip column with the title still mounted to the right for the width ease.
        open ? 'gap-2.5 px-5' : '',
      )}
    >
      <span className={cn('flex shrink-0 items-center justify-center', !open && 'w-mini-drawer')}>
        {/* The mark is a coloured PNG; render it as a white silhouette on the dark rail. */}
        <Logo isIcon className="brightness-0 invert" />
      </span>
      <span
        className="min-w-0 flex-1 truncate text-base font-semibold tracking-title text-sidebar-ink"
        aria-hidden={!open}
      >
        Food Auditor
      </span>
    </div>
  );
};

export default DrawerHeader;
